import React, { useContext, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { UserContext } from '../../../context/UserProvider';
import { IconButton, Switch, Typography } from '@mui/material';
import { ConfirmarPedido } from '../../Pedido/ConfirmarPedido';
import { useGetEditArteFinal, useUpdateArteFinal } from '../../../hooks/useArteFinal';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import MaterialTooltip from '../../../ui/tooltip/MaterialTooltip';

const HeaderArteFinal = ({ infoArteFinal }) => {
  const { idArte } = useParams();
  const { data } = useGetEditArteFinal(idArte);
  const editData = data?.data;
  const activeValue = editData?.arteFinal?.active ?? infoArteFinal.active;
  const { userRole } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [openPopoverSwitch, setOpenPopoverSwitch] = useState(null);

  const { mutation } = useUpdateArteFinal(idArte, false); //el false es para que no se cierre

  const handleReturnAllArtes = () => {
    let newPath = location.pathname;

    if (location.pathname.endsWith('/')) {
      newPath = newPath.slice(0, -1);
    }

    newPath = newPath.substring(0, newPath.lastIndexOf('/'));

    navigate(newPath || '/', { replace: true });
  };

  const handleOpenSwitchPopover = (e) => {
    setOpenPopoverSwitch(e.currentTarget);
  };

  const handleCloseSwitchPopover = () => {
    setOpenPopoverSwitch(null);
  };

  const handleSwitchChange = () => {
    if (!editData?.arteFinal) {
      return;
    }

    const { arteFinal, category } = editData;

    const initialValues = {
      code: arteFinal.code,
      name: arteFinal.name,
      category,
      centerType: arteFinal.centerType,
      favourite: arteFinal.favourite,
      active: arteFinal.active,
      isImagenNueva: arteFinal.isImagenNueva,
      isImagenAnterior: arteFinal.isImagenAnterior,
      isMontaje: arteFinal.isMontaje,
      minQuantity: arteFinal.minQuantity,
      regional: arteFinal.regional,
      tags: arteFinal.tags || [],
      tagsInput: (arteFinal.tags || []).join(', '),
    };

    const tagsProcesados = initialValues.tagsInput
      .split(',')
      .map((t) => t.trim())
      .filter((t) => t.length > 0);

    const valuesConTags = {
      ...initialValues,
      active: !initialValues.active,
      tags: tagsProcesados,
    };

    mutation.mutate(valuesConTags);
    handleCloseSwitchPopover();
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', height: '35px', alignItems: 'center' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '1rem',
          textAlign: 'center',
          marginLeft: '1rem',
        }}
      >
        <p
          style={{ marginRight: '1rem', cursor: 'pointer', fontSize: 'large' }}
          onClick={handleReturnAllArtes}
          className="return-tooltip-catalogo"
        >
          Volver
        </p>
        <Tooltip anchorSelect=".return-tooltip-catalogo" place="bottom">
          <span>Volver a todos los artes finales</span>
        </Tooltip>
        <p style={{ fontSize: 'large' }}> {'>'} </p>
        <p style={{ marginLeft: '1rem', fontSize: 'large', fontWeight: 800 }}>{infoArteFinal.code}</p>{' '}
        <p style={{ fontSize: 'large', margin: '0 1rem 1rem 1rem' }}> -</p>{' '}
        <p style={{ fontSize: 'large' }}>
          {infoArteFinal.name.length > 50 ? infoArteFinal.name.substring(0, 50) + '...' : infoArteFinal.name}
        </p>
        {userRole === 'MasterAdmin' && (
          <div style={{ margin: '0 0 1rem 4rem' }}>
            <Switch
              className="switch-validate-tooltip"
              checked={!!activeValue}
              onChange={(e) => handleOpenSwitchPopover(e)}
            />
          </div>
        )}
        {infoArteFinal.active ? (
          <Tooltip anchorSelect=".switch-validate-tooltip" place="bottom">
            <span>Desactivar Arte Final</span>
          </Tooltip>
        ) : (
          <Tooltip anchorSelect=".switch-validate-tooltip" place="bottom">
            <span>Activar Arte Final </span>
          </Tooltip>
        )}
        <div style={{ margin: '0 0 1rem 25rem' }}>
          {infoArteFinal.issues.length > 0 && (
            <MaterialTooltip
              variation="warning"
              title={
                <React.Fragment>
                  <Typography
                    color="inherit"
                    style={{
                      fontWeight: 'bold',
                    }}
                  >
                    Articulo con problemas
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{
                      padding: '0 0 1rem 0',
                    }}
                  >
                    Este articulo no se mostrara en la lista de artes finales porque tiene los siguientes problemas.
                  </Typography>
                  <ul>
                    {infoArteFinal.issues.map((issue) => (
                      <li key={issue}>{issue?.message}</li>
                    ))}
                  </ul>
                </React.Fragment>
              }
            >
              <IconButton className="alert-message">
                <span
                  style={{
                    fontSize: '1rem',
                  }}
                >
                  ({infoArteFinal.issues.length})
                </span>
                <ReportProblemIcon color="warning" />
              </IconButton>
            </MaterialTooltip>
          )}
        </div>
      </div>

      <ConfirmarPedido
        confirmarPedidoPopover={openPopoverSwitch}
        handleCloseConfirmarPedidoPopover={handleCloseSwitchPopover}
        handleDeleteConfirm={handleSwitchChange}
        mensaje="¿Está seguro que desea cambiar el estado (activo/inactivo) del arte final?"
      />
    </div>
  );
};

export default HeaderArteFinal;
